import HttpService from "./htttp.service";

function normalizeTemplateKpi(templateKpi) {
  if (!templateKpi) return templateKpi;

  const description = templateKpi.description ?? templateKpi?.kpi?.description;
  const allLanguageDescription =
    templateKpi.allLanguageDescription ??
    templateKpi?.kpi?.allLanguageDescription;

  return {
    ...templateKpi,
    description,
    allLanguageDescription,
    kpi: templateKpi.kpi
      ? {
          ...templateKpi.kpi,
          description: templateKpi.kpi.description ?? description,
          allLanguageDescription:
            templateKpi.kpi.allLanguageDescription ?? allLanguageDescription,
          pillar: templateKpi.kpi.pillar
            ? {
                ...templateKpi.kpi.pillar,
                description: templateKpi.kpi.pillar.description,
              }
            : templateKpi.kpi.pillar,
        }
      : templateKpi.kpi,
  };
}

function normalizeTemplate(template) {
  if (!template) return template;

  return {
    ...template,
    subcategory: template.subcategory
      ? {
          ...template.subcategory,
          description: template.subcategory.description,
          category: template.subcategory.category
            ? {
                ...template.subcategory.category,
                description: template.subcategory.category.description,
              }
            : template.subcategory.category,
        }
      : template.subcategory,
    templateKpis: Array.isArray(template.templateKpis)
      ? template.templateKpis.map(normalizeTemplateKpi)
      : template.templateKpis,
  };
}

function normalizeTemplatesResponse(data) {
  if (Array.isArray(data)) {
    return data.map(normalizeTemplate);
  }

  if (data && Array.isArray(data.data)) {
    return {
      ...data,
      data: data.data.map(normalizeTemplate),
    };
  }

  return normalizeTemplate(data);
}

class AuditTemplatesService {
  getAuditTemplates = async (query, cancelToken) => {
    const endpoint = "audit-templates";
    const [response, data] = await HttpService.get(endpoint, query, cancelToken);
    return [response, normalizeTemplatesResponse(data)];
  };

  createAuditTemplate = async (payload, query = {}) => {
    const endpoint = "audit-templates";
    return await HttpService.post(endpoint, payload, query);
  };

  updateAuditTemplate = async (id, payload) => {
    const endpoint = "audit-templates/" + id;
    return await HttpService.put(endpoint, payload);
  };

  removeAuditTemplate = async (id) => {
    const endpoint = "audit-templates/" + id;
    return await HttpService.delete(endpoint);
  };
}

export default new AuditTemplatesService();
